import { createSlice } from '@reduxjs/toolkit';
import { asSliceActions, asSliceSelectors } from '../types';
var SLICE_NAME = 'misc';
/**
 * ATM main purpose of slice usage: is to be readonly
 */
var rawSlice = createSlice({
    name: SLICE_NAME,
    initialState: {},
    reducers: {},
});
var selectors = asSliceSelectors({});
var actions = asSliceActions({
    // only that action creator should be used for internal redirects
    // out of router boundaries, to be ensure that possible storages was
    // teardown correctly
    redirectAppToPage: function (url) { return function () {
        window.location.href = url;
    }; },
});
export var miscSlice = {
    name: SLICE_NAME,
    actions: actions,
    selectors: selectors,
};
export default rawSlice.reducer;
